import { ReactNode, useState } from "react";
import {
  PopoverContent,
  PopoverPortal,
  PopoverTrigger,
  Root,
} from "@radix-ui/react-popover";
import { TEcosystem, TTag } from "screens/DApps/types";
import { Plus } from "assets/icons/Plus";
import clsx from "clsx";

type TProps = {
  availableEcosystems: TEcosystem[];
  selectedEcosystems: TEcosystem[];
  onEcosystemClick: (tag: TTag) => void;
  children: ReactNode;
};

export const EcosystemsDropdown = ({
  children,
  availableEcosystems,
  onEcosystemClick,
  selectedEcosystems,
}: TProps) => {
  const [isOpen, setIsOpen] = useState(false);

  const stopPropagation = (e: React.MouseEvent<Element, MouseEvent>) => {
    e.stopPropagation();
  };

  const isEcosystemSelected = (ecosystem: TEcosystem) => {
    return selectedEcosystems.some(
      (selectedEcosystem) => selectedEcosystem.id === ecosystem.id
    );
  };

  const handleClick = (ecosystem: TEcosystem) => {
    onEcosystemClick(ecosystem);
  };

  return (
    <Root open={isOpen} onOpenChange={setIsOpen}>
      <PopoverTrigger asChild>{children}</PopoverTrigger>
      <PopoverPortal>
        <PopoverContent asChild className="bg-[#111111]  w-[406px] z-[10]">
          <div
            className="overflow-auto custom-scrollbar max-h-[300px]"
            onClick={stopPropagation}
          >
            {availableEcosystems.map((ecosystem) => (
              <div
                className={clsx(
                  "p-2 flex gap-4 items-center hover:bg-[#FFFFFF1A] cursor-pointer hover:text-[#FFC93D]",
                  isEcosystemSelected(ecosystem) && "text-[#FFC93D]"
                )}
                key={ecosystem.id}
                onClick={() => handleClick(ecosystem)}
              >
                {ecosystem.name}
                {isEcosystemSelected(ecosystem) ? (
                  <span className="ml-auto mr-0.5 text-[24px] leading-[10px]">
                    -
                  </span>
                ) : (
                  <Plus className="ml-auto" />
                )}
              </div>
            ))}
          </div>
        </PopoverContent>
      </PopoverPortal>
    </Root>
  );
};
